<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button size="small"    type="primary" icon="el-icon-plus" @click="editFormVisible = true" style="margin-top: 20px;margin-bottom: 20px;">添加</el-button>
    <!--列表-->
    <el-table size="small" :header-cell-style="{
      background:'#00A0FF',color:'white',border: '1px solid tan'}" :row-class-name="tableRowClassName" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="50">
      </el-table-column>
      <el-table-column prop="title" align="center" label="标题">
      </el-table-column>
      <el-table-column prop="subtitle" align="center" label="副标题">
      </el-table-column>
      <el-table-column prop="why" align="center" label="问候语">
      </el-table-column>
      <el-table-column prop="content" align="center" label="内容" width="300">
      </el-table-column>
 <el-table-column prop="ewm_url" align="center" label="二维码" width="80" show-overflow-tooltip>
     <template slot-scope="scope">
       <div class="ylt" >
         <img :src="scope.row.ewm_url" @click="yulandatu(scope.row.ewm_url,scope.row)">
       </div>

      </template>

 </el-table-column>
      <el-table-column prop="create_time" align="center" label="添加时间">
      </el-table-column>


      <el-table-column align="center" label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="editque(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delque(scope.row.id,scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="bianji" :visible.sync="editFormVisible" width="800px" @click='editFormVisible = false'>
      <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="标题" prop="project">
          <el-input type="input" v-model="editForm.title" placeholder="请输入标题" style="width: 240px;"></el-input>
        </el-form-item>
        <el-form-item label="副标题" prop="project">
          <el-input type="input" v-model="editForm.subtitle" placeholder="请输入副标题" style="width: 240px;"></el-input>
        </el-form-item>
        <el-form-item label="问候语" prop="project">
          <el-input type="input" v-model="editForm.why" placeholder="请输入问候语" style="width: 240px;"></el-input>
        </el-form-item>

        <el-form-item label="内容" prop="ask">
          <el-input type="textarea" rows=8 v-model="editForm.content" placeholder="请输入内容"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='editFormreset'>重置</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title"
         @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="" :visible.sync="yulan">

      <div style="text-align: center; margin:0 auto" class="ewmtp">
          <img :src="imgUrl" >
      </div>
      <div class="xiazai" style="" >{{title}}</div>
     <!-- <div class="xiazai" style="" @click="downloadImage(imgUrl)">点击下载</div>
 -->

    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import { saveQuestion,qusetionList,saveStatus,delActive,activelist,saveActive} from '../../api/baseset'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false,
        editForm: {
          title: '1',
          subtitle: '1',
          why: '1',
          content: '1',
        },
        title:'',
        yulan:false,
        // rules表单验证
        rules: {
          title: [
            { required: true, message: '请输入标题', trigger: 'blur' }
          ],
          subtitle: [
            { required: true, message: '请输入副标题', trigger: 'blur' }
          ],
          why: [
            { required: true, message: '请输入问候语', trigger: 'change' }
          ],
          content: [
            { required: true, message: '请输入内容', trigger: 'change' }
          ]
        },
        // 请求数据参数
        formInline: {
          page: 1,
          limit: 10,
          key: ''
        },
        bianji:'添加',
        //表格数据
        listData: [],
        imgUrl:'',
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    created() {
      this.getdata(this.formInline)
    },
    methods: {
      getdata(param) {
        this.loading = true;
        activelist(param).then(res => {
          console.log(res)
          this.loading = false;
          this.listData = res.data;
          // 分页赋值
          this.pageparm.currentPage = this.formInline.page
          this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.count
        })
      },
      editFormreset() {
        this.editForm = {status: '1',type: '1'};
      },
      // 提交
      submitForm(editData) {

        this.$refs[editData].validate(valid => {

          if (valid) {
            let data = this.editForm;

            saveActive(data)
            .then(res => {
              if(res.code == 0){
                this.editFormreset();
                this.editFormVisible = false;
                this.getdata(this.formInline);
                this.$message({
                  type: 'success',
                  message: res.msg
                });
              }else{
                this.$message.error(res.msg);
              }
            })
            .catch(e => {
              this.$message.error('操作失败，请稍后再试！')
            })
          } else {
            return false
          }
        })
      },
      add(){
          this.bianji = '添加'
         this.editForm.title = '';
         this.editForm.subtitle = '';
         this.editForm.why = '';
         this.editForm.id = 0;
         this.editForm.content = '';
         this.editFormVisible = true;
      },
      editque(row) {
        //row.type = row.type.toString();
        this.editForm = row;
        console.log(row)
        this.bianji = '编辑'

        this.editFormVisible = true;
      },
      editStatus(row) {
        let data = {id:row.id,status:row.status};
        saveStatus(data)
        .then(res => {
          if(res.code == 0){
            this.$message({
              type: 'success',
              message: res.msg
            });
          }else{
            this.$message.error(res.msg);
            this.getdata(this.formInline);
          }
        })
        .catch(e => {
          this.$message.error('操作失败，请稍后再试！')
          this.getdata(this.formInline);
        })
      },
      delque(id,index) {
        this.$confirm('您确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //console.log(44444)
          let data = {id:id};
         // console.log(44444)
          delActive(data).then(res => {
            console.log('res',res)
            if(res.code == 0){
              this.listData.splice(index, 1);
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.getdata(this.formInline);
            }else{
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 1) {
              return 'success-row' //这是类名
            } else  {
              return ''
            }
      },
      yulandatu(url,row){
        console.log(url)
        console.log(row)
        this.title = row.title
        this.imgUrl = url;
        this.yulan = true
      },
      /**
       * imageUrl: 要下载的图片地址
       * name: 下载后的图片名称
       */
      downloadImagea(imageUrl, name) {
        const image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute('crossOrigin', 'anonymous');
        image.onload = function () {
          const canvas = document.createElement('canvas');
          canvas.width = image.width;
          canvas.height = image.height;
          const context = canvas.getContext('2d');
          context.drawImage(image, 0, 0, image.width, image.height);
          // 得到图片的base64编码数据
          const url = canvas.toDataURL('image/png');

          // 生成一个a元素
          const a = document.createElement('a');
          // 创建一个单击事件
          const event = new MouseEvent('click');
          a.download = name;
          // 将生成的URL设置为a.href属性
          a.href = url;
          // 触发a的单击事件
          a.dispatchEvent(event);
        };
        image.src = imageUrl;
      },
       async downloadImage(imageUrl) {
           // 获取图片对象和画布对象
           const imgUrl = imageUrl
           const response = await fetch(imgUrl)
           const blob = await response.blob()
           // 创建下载链接
           const url = window.URL.createObjectURL(blob)
           const link = document.createElement('a')
           link.href = url
           link.download = 'image.png'
           document.body.appendChild(link)
           link.click()
           document.body.removeChild(link)
           // 释放 Blob URL
           window.URL.revokeObjectURL(url)
         }
    }

  }
</script>

<style>
  .change{margin-top: 10px;}
  .success-row {
      background-color:#eaf3fb !important;

  }
  .ylt img{
  width: 60px;
  height: 60px;

  }
  .xiazai{
   margin: 0 auto; text-align: center;margin-top: 10px; width: 100%;height: 30px;
   border-radius: 5px 5px 5px 5px;color: #666666;line-height: 30px;
  /* border: solid 1px red; */
   margin-left: -4px;
  }
  .ewmtp img{
    margin-left: -5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/active/activelist.vue